import React from "react";
var i18nContext = /*#__PURE__*/React.createContext();
var servicesContext = /*#__PURE__*/React.createContext([]);
var idContext = /*#__PURE__*/React.createContext({
  accountContext: "",
  bssAccount: "",
  envId: "",
  toolchainId: ""
});
export { idContext, i18nContext, servicesContext };